import { CoveoSearchHub } from '@lib/coveo/coveoConstants';
import { InitEngineOptions, createEngineModule } from './createEngineModule';

export const listingModule = createEngineModule(CoveoSearchHub.LISTING);

const {
  initEngine: initListingEngine,
  engine: listingEngine,
  resetEngine: resetListingEngine,
} = listingModule;

export { initListingEngine, listingEngine, resetListingEngine };
export type { InitEngineOptions as InitListingEngineOptions };
